'use client';

import { FC } from 'react';
import { SendRequestForm } from '@/components';
import { IHousingObjectResponse } from '@/types';
import { AsideBox, AsideContainer } from './styled';
import { ProtectedInformation } from '../AgentData/ProtectedInformation';

type AsideBrokerInfoShellProps = {
  housingId: string;
  hasInfoRequest: boolean;
  brokerData: IHousingObjectResponse['brokerData'];
  listingData?: IHousingObjectResponse | null;
  children: React.ReactNode;
};

export const AsideBrokerInfoShell: FC<AsideBrokerInfoShellProps> = ({
  housingId,
  hasInfoRequest,
  brokerData,
  listingData,
  children,
}) => {
  return (
    <AsideContainer>
      <AsideBox>
        {children}
        {brokerData && (
          <ProtectedInformation
            objectId={housingId}
            phone={brokerData.contactPhone?.number}
            mobile={brokerData.contactMobile?.number}
            email={brokerData.contactEmail}
          />
        )}
        <SendRequestForm
          objectId={housingId}
          whatsappDisabled={brokerData?.whatsappDisabled ?? false}
          hasInfoRequest={hasInfoRequest}
          listingData={listingData}
        />
      </AsideBox>
    </AsideContainer>
  );
};
